import controller from './order-card.controller';
import template from './order-card.html';

// import dsOrderCard from './OrderCard.vue';

function OrderCard() {
    return {
        restrict : 'E',
        scope : {
            'order' : '='
        },
        template : template,
        controller : controller,
        controllerAs : 'vm',
        bindToController : true
    }
}
/* .directive('dsOrderCard', ['createVueComponent', function (createVueComponent) {
        return createVueComponent(Vue.component('dsOrderCard', dsOrderCard))
     }])
     */
export default angular.module( 'directives.order-card', [] )
    .directive('dcOrderCard', OrderCard)
    .controller('OrderCardController', controller );
